import { BQ_API_URL } from 'helpers/conf';

export interface RiskSegmentResponse {
  data: { user_id: string; segment_id: string };
  meta: { version: string };
}

const REQUEST_TIMEOUT_MS = 5000;

export const fetchRiskSegment = async (
  userId: number | string
): Promise<RiskSegmentResponse['data'] | null> => {
  if (!BQ_API_URL) return null;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(
      `${BQ_API_URL}/api/v1/risk-segment/${userId}`,
      { signal: controller.signal }
    );
    if (!response.ok) return null;
    const json = (await response.json()) as RiskSegmentResponse;
    return json?.data ?? null;
  } catch (e) {
    console.warn('fetchRiskSegment failed:', e);
    return null;
  } finally {
    clearTimeout(timeoutId);
  }
};
